import Vue from 'vue'
import Vuetify from 'vuetify'
import {sync} from 'vuex-router-sync'
import Amplify from 'aws-amplify';
import App from './components/App'
import router from './router'
import store from './store'

import '../../.././node_modules/vuetify/dist/vuetify.min.css'

import './filters'

Vue.config.productionTip = false;

Amplify.configure({
  Auth: profileConfig.auth,
  Storage: profileConfig.storage
});

Vue.use(Vuetify,   {icons: {
  iconfont: 'fa4'
}}
);

const isDev = process.env.NODE_ENV === 'development'

Vue.prototype.isDev = isDev
Vue.prototype.profile = profileConfig.endpoints

sync(store, router)

const app = new Vue({
  vuetify : new Vuetify(),
  router,
  store,
  ...App

})

export {app, router, store}



// WEBPACK FOOTER //
// ./client/app.js